<template>
    <div class="row-sezione">
        <div class="container">
            <swiper :options="this.options" @click-slide="this.clickSlide" ref="swiper">
                <swiper-slide v-for="(item, i) in this.entries"
                              class="d-flex flex-column align-items-center justify-content-center data"
                              :key="i"
                              :class="{'active': i === curr_idx}">
                    {{item.primaryText}}
                    <span v-if="item.secondaryText">
                        {{item.secondaryText}}
                    </span>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev" @click="this.snapToPrev"></div>
                <div class="swiper-button-next" slot="button-next" @click="this.snapToNext"></div>
            </swiper>
        </div>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import config from '../../../../configs/swiper-options.json';


export default {
    name: "OptionsCarousel",
    components: {Swiper, SwiperSlide},
    props: ['entries', 'initialIdx'],
    data() {
        return {
            curr_idx: this.initialIdx ? this.initialIdx : 0,
            options: config
        };
    },
    mounted() {
        this.$refs.swiper.$swiper.slideTo(this.curr_idx);
        this.clickSlide(this.curr_idx);
    },
    methods: {
        clickSlide: function (index) {
            this.curr_idx = index;
            this.$emit('onSnapToItem', index);
        },
        snapToPrev: function () {
            this.clickSlide(this.curr_idx - 1);
        },
        snapToNext: function () {
            this.clickSlide(this.curr_idx + 1);
        }
    }
}
</script>
